import { useState, useEffect, useCallback } from "react";
import { Api } from "../request/api/api";
import { SaveSkillBranchDto, SkillBranchDict } from "../model/Dto/Dict/Skill";

export function useSkillBranches() {
    const [skillBranches, setSkillBranches] = useState<SkillBranchDict[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchSkillBranches = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.getAllSkillBranches();
            setSkillBranches(result);
        } catch (err) {
            setError("Ошибка загрузки веток навыков");
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    const createSkillBranch = useCallback(async (data: SaveSkillBranchDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.createSkillBranch(data);
            if (result) { await fetchSkillBranches(); return true; }
            setError("Ошибка создания ветки навыков");
            return false;
        } catch (err) {
            setError("Ошибка создания ветки навыков");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchSkillBranches]);

    const updateSkillBranch = useCallback(async (id: string, data: SaveSkillBranchDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.updateSkillBranch(id, data);
            if (result) { await fetchSkillBranches(); return true; }
            setError("Ошибка обновления ветки навыков");
            return false;
        } catch (err) {
            setError("Ошибка обновления ветки навыков");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchSkillBranches]);

    const deleteSkillBranch = useCallback(async (id: string) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.deleteSkillBranch(id);
            if (result) { await fetchSkillBranches(); return true; }
            setError("Ошибка удаления ветки навыков");
            return false;
        } catch (err) {
            setError("Ошибка удаления ветки навыков");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchSkillBranches]);

    useEffect(() => {
        fetchSkillBranches();
    }, [fetchSkillBranches]);

    return { skillBranches, loading, error, createSkillBranch, updateSkillBranch, deleteSkillBranch };
}
